<template>
    <div class="child">
        <h3>{{boardName}}</h3>
        <Card
        v-for="task in lists"
        :item="task" 
        :key="task.id"
        @reloadTask="reload"
        ></Card>
    </div>
</template>

<script>
import Card from "./Card"
export default {
    name: "BoardCategory",
    props: {
        lists: Array,
        boardName: String
    },
    components: {
        Card
    },
    methods: {
        reload() {
            this.$emit('updateTask')
        }
    }
}
</script>